var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"to":_vm.localePath('/contact-us'),"color":_vm.color,"dark":"","large":"","depressed":""}},'v-btn',_vm.$props,false),[_vm._v(_vm._s(_vm.$t('Common.Buttons.ContactProjectManager')))])}
var staticRenderFns = []

export { render, staticRenderFns }